import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const OffTheRecord = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.offTheRecord.title')}
      contentType="offTheRecord30"
      description={t('page.offTheRecord.desc')}
      outputLabel={t('page.offTheRecord.output')}
    />
  );
};
